import React from 'react';
import { Alert, Card, List, Typography } from 'antd';

const { Text } = Typography;

const AnalysisResults = ({ extractedData, analysisComplete }) => {
  if (!analysisComplete) return null;

  return (
    <>
      {/* Debug info */}
      {process.env.NODE_ENV === 'development' && (
        <div style={{ marginBottom: 16, padding: '8px', backgroundColor: '#f0f0f0', borderRadius: '4px', fontSize: '12px' }}>
          <strong>Debug Info:</strong><br/>
          New Suppliers: {extractedData.newSuppliers?.length || 0}<br/>
          New Products: {extractedData.newProducts?.length || 0}<br/>
          Existing Products: {extractedData.existingProducts?.length || 0}
        </div>
      )}

      {extractedData.newSuppliers && extractedData.newSuppliers.length > 0 && (
        <div style={{ marginBottom: 24 }}>
          <Alert
            message="New Supplier Will Be Added"
            type="info"
            showIcon
          />
          <Card title="New Supplier Details" size="small" style={{ marginTop: 8 }}>
            {extractedData.newSuppliers.map((supplier, index) => (
              <div key={index} style={{ marginBottom: 16 }}>
                <p><strong>Name:</strong> {supplier.name}</p>
                <p><strong>Phone:</strong> {supplier.phone || 'Not provided'}</p>
                <p><strong>Address:</strong> {supplier.address || 'Not provided'}</p>
              </div>
            ))}
          </Card>
        </div>
      )}

      {extractedData.newProducts && extractedData.newProducts.length > 0 && (
        <div style={{ marginBottom: 24 }}>
          <Alert
            message={`${extractedData.newProducts.length} New Products Will Be Added`}
            type="info"
            showIcon
          />
          <Card title="New Products Details" size="small" style={{ marginTop: 8 }}>
            <List
              size="small"
              dataSource={extractedData.newProducts}
              renderItem={(product, index) => (
                <List.Item>
                  <div style={{ width: '100%' }}>
                    <Text strong>{product.title || `Product ${index + 1}`}</Text>
                    <br />
                    <Text>ISBN: {product.isbn || 'N/A'}</Text> | 
                    <Text> Author: {product.author || 'N/A'}</Text> | 
                    <Text> Publisher: {product.publisher || 'N/A'}</Text>
                    <br />
                    <Text>Qty: {product.quantity || 'N/A'}</Text> | 
                    <Text> Price: ₹{product.price || 'N/A'}</Text> | 
                    <Text> Currency: {product.currency || 'N/A'}</Text> | 
                    <Text> Discount: {product.discount || '0'}%</Text>
                  </div>
                </List.Item>
              )}
            />
          </Card>
        </div>
      )}

      {extractedData.existingProducts && extractedData.existingProducts.length > 0 && (
        <div style={{ marginBottom: 24 }}>
          <Alert
            message={`${extractedData.existingProducts.length} Existing Products Found`}
            type="success"
            showIcon
          />
          <Card title="Existing Products" size="small" style={{ marginTop: 8 }}>
            <List
              size="small"
              dataSource={extractedData.existingProducts}
              renderItem={(product, index) => (
                <List.Item>
                  <div style={{ width: '100%' }}>
                    <Text strong>{product.name || `Product ${index + 1}`}</Text>
                    <br />
                    <Text>ISBN: {product.isbn || 'N/A'}</Text> | 
                    <Text> Author: {product.author || 'N/A'}</Text> | 
                    <Text> Publisher: {product.book_publisher?.name || 'N/A'}</Text>
                    <br />
                    <Text>Qty: {product.extractedQuantity || 'N/A'}</Text> | 
                    <Text> Price: ₹{product.extractedPrice || 'N/A'}</Text> | 
                    <Text> Currency: {product.product_currency?.symbol || 'N/A'}</Text> | 
                    <Text> Discount: {product.extractedDiscount || '0'}%</Text>
                  </div>
                </List.Item>
              )}
            />
          </Card>
        </div>
      )}

      {(!extractedData.newSuppliers?.length && !extractedData.newProducts?.length && !extractedData.existingProducts?.length) && (
        <Alert
          message="No new items to add"
          description="All suppliers and products already exist in the system."
          type="success"
          showIcon
        />
      )}
    </>
  );
};

export default AnalysisResults;
